import { render, staticRenderFns } from "./alignCenter_off.vue?vue&type=template&id=df05207e&"
import script from "./alignCenter_off.vue?vue&type=script&lang=ts&"
export * from "./alignCenter_off.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports